import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const Layout = () => (
  <div className="flex min-h-screen flex-col bg-white">
    <Header />
    <main className="flex-1"><Outlet /></main>
    <Footer />
  </div>
);

export const PageHero = ({ title, sub, children }) => (
  <section className="bg-gradient-to-b from-osk-light to-white">
    <div className="osk-container py-12 md:py-16">
      <h1 className="osk-rise text-4xl sm:text-5xl">{title}</h1>
      {sub && <p className="osk-rise mt-4 max-w-2xl text-base text-osk-text md:text-lg">{sub}</p>}
      {children}
    </div>
  </section>
);

export const Spinner = () => (
  <div className="flex justify-center py-20" data-testid="loading-spinner">
    <div className="h-9 w-9 animate-spin rounded-full border-4 border-osk-light border-t-osk-blue" />
  </div>
);
